const state = () => ({
  evaluationHelp: null,
  evaluationText: '',
  evaluationAnswerId: null,
  evaluationServiceType: '',
  evaluationServiceEntityId: '',
  evaluationSending: false,
  evaluationSkipping: false
});

const getters = {
  evaluationHelp(state) {
    return state.evaluationHelp;
  },
  evaluationText(state) {
    return state.evaluationText;
  },
  evaluationAnswerId(state) {
    return state.evaluationAnswerId;
  },
  evaluationServiceType(state) {
    return state.evaluationServiceType;
  },
  evaluationServiceEntityId(state) {
    return state.evaluationServiceEntityId;
  },
  evaluationSending(state) {
    return state.evaluationSending;
  },
  evaluationSkipping(state) {
    return state.evaluationSkipping;
  }
};

const mutations = {
  setEvaluationHelp(state, payload) {
    state.evaluationHelp = payload;
  },
  setEvaluationText(state, payload) {
    state.evaluationText = payload;
  },
  setEvaluationAnswerId(state, payload) {
    state.evaluationAnswerId = payload;
  },
  setEvaluationServiceType(state, payload) {
    state.evaluationServiceType = payload;
  },
  setEvaluationServiceEntityId(state, payload) {
    state.evaluationServiceEntityId = payload;
  },
  setEvaluationSending(state, payload) {
    state.evaluationSending = payload;
  },
  setEvaluationSkipping(state, payload) {
    state.evaluationSkipping = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  resetEvaluation({ commit }) {
    commit('setEvaluationHelp', null);
    commit('setEvaluationText', '');
    commit('setEvaluationAnswerId', null);
    commit('setEvaluationServiceType', '');
    commit('setEvaluationServiceEntityId', '');
    commit('setEvaluationSending', false);
    commit('setEvaluationSkipping', false);
  }
};

export const evaluation = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
